<!-- /src/views/FunnelLanding.vue -->
<template>
  <LayoutFullWidth class="layout--session">
    <template v-slot:header>
      <h1
        class="page-header"
        v-html="post.title.rendered"
      ></h1>
    </template>
    <template v-slot:content v-if="post">
      <div class="layout--session--container">
        <div class="body-content">
          <div v-if="!isVideo" class="session__image">
            <img :src="post.featured_media.post" alt="" />
          </div>
          <MediaPlayer v-if="hasMedia" :post="post" :startTime="startTime" />
          <TableOfContents v-if="hasMedia" :post="post" @jumpTo="updateStartTime" />
          <div class="session__body-content">
            <div v-if="bodyContent" v-html="bodyContent"></div>
          </div>
        </div>
        <div class="additional-elements">
          <div v-if="downloadableFiles.length > 0" class="session__attachments">
            <h2 class="session__attachments__title">Downloadable Items</h2>
            <Downloadable
              v-for="(file, index) in downloadableFiles"
              :key="`attachment_ind_${index}`"
              :file="file"
            />
          </div>
          <div v-if="relatedContent"
            class="session__related-content--container"
          >
            <h2 class="session__attachments__title">Related Content</h2>
            <ul class="session__related-content--container__items">
              <li class="session__related-content--container__item"
                v-for="(related, index) in relatedContent"
                :key="index"
              >
                <Card :post="related" :type="type" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
    <Loader v-else class="session__body-content" color="gray" />
  </LayoutFullWidth>
</template>

<script>
import isUndefined from 'lodash/isUndefined'
import LayoutFullWidth from '@/components/layouts/FullWidth'
import TableOfContents from '@/components/MediaElements/TableOfContents'
import MediaPlayer from '@/components/Session/Media'
// import FunnelHeader from '@/components/FunnelLanding/Header'
import Downloadable from '@/components/common/Downloadable'
import Loader from '@/components/common/Loaders/Loader'
import secondsConversions from '@/components/common/utils/filters/secondConversions'
import postMixin from '@/mixins/postMixin'
import { deepSearch } from '@/components/common/utils/helpers.js'
import Card from '@/components/common/Card/Card'

export default {
  mixins: [postMixin],

  data() {
    return {
      tocVisible: false,
      startTime: 0,
      completeLoading: false,
    }
  },

  computed: {
    post() {
      const post = this.$store.getters['posts/findItemByProp'](
        'funnelLandingPages',
        this.$route.params.slug,
        'slug',
      )
      return post
    },

    bodyContent() {
      const { section_content } = this.post.acf
      let output = ''
      if (section_content && section_content.length > 0) {
        section_content.forEach(section => {
          output += `${section.title}${section.content}`
        })
      }
      return output
    },

    isVideo() {
      if (this.post.session_type[0] === 'video') {
        return true
      }
      return false
    },

    hasMedia() {
      if (
        this.post.session_type[0] === 'video' ||
        this.post.session_type[0] === 'audio'
      ) {
        return true
      }
      return false
    },

    downloadableFiles() {
      const { post } = this
      const files = []
      let downloadableFiles = deepSearch(post, ['acf', 'downloadable_files'])
      if (Array.isArray(downloadableFiles)) {
        downloadableFiles.forEach(file => {
          files.push(file.file)
        })
        return files
      }
      return false
    },
  },

  filters: {
    ...secondsConversions,
  },

  methods: {
    updateStartTime(event) {
      this.startTime = event
    },

    jumpToTime(time) {
      this.startTime = time
    },

    checkForCurrentTimestamp() {
      if (!isUndefined(this.currentInteraction)) {
        if ( this.currentInteraction.mediaType == 'video' || this.currentInteraction.mediaType == 'audio' ) {
          this.jumpToTime(this.currentInteraction.timestamp)
        }
      } else {
        setTimeout(() => {
          this.checkForCurrentTimestamp()
        }, 500)
      }
    }
  },

  components: {
    LayoutFullWidth,
    Loader,
    MediaPlayer,
    // FunnelHeader,
    Downloadable,
    Card,
    TableOfContents,
  },

  mounted() {
    this.visitedPost()
    this.checkForCurrentTimestamp()
  },
}
</script>

<style scoped>
.page-header {
  margin: 0;
}
.layout--session {
  &.layout__content__columns {
    grid-template-columns: 25rem auto;
  }


  &--container {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 2rem;

    @media (--desktop) {
      grid-template-columns: 1fr 1fr;
    }
  }

  .session {
    &__content {
      border-radius: var(--borderRadiusSmall);
      /* overflow: hidden; */

      @media (--tablet) {
        border-radius: 0;
      }
    }

    &__image {
      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }

    &__body-content {
      padding: var(--itemSpacing) 0 0 0;
      width: 100%;
      max-width: calc(100% - 2rem);

      a {
        text-decoration: underline;
      }

      ol {
        list-style: decimal;
        margin-left: 1rem;

        li {
          ol {
            list-style: lower-alpha;
            margin-left: 1.5rem;
          }
        }
      }

      ul {
        margin-left: 1rem;
        list-style-type: square;
      }

      blockquote {
        border-left: 5px solid var(--gray);
        padding-left: 1rem;
      }
    }

    &__attachments {
      &__title {
        color: var(--gray);
        font-weight: var(--fontWeightBold);
        font-size: 0.8em;
        text-transform: uppercase;
        margin: 0 0 0.5rem;
      }
    }

    &__related-content {
      &--container {
        margin-bottom: 3rem;
        &__items {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(8rem, 1fr));
          grid-gap: .5rem;
        }
      }
    }
  }

  .additional-elements {
    > div {
      margin-bottom: 2rem;

      &:last-child {
        margin-bottom: 0
      }
    }
  }
}
</style>
